import { motion } from 'framer-motion'

import { useMenuContext } from 'context/menu-context'
import { useMenuItem } from 'hooks/useMenuItem'

import { Images } from './images'
import {
  Header,
  IntroText,
  Left,
  Right,
  ScrollButton,
  Small,
  StyledIconArrow,
  TextContent,
  Title,
} from './styled'
import {
  headerVariants,
  introVariants,
  titlePartVariants,
  titleVariants,
} from './variants'

export const Intro = () => {
  const { menuItems } = useMenuContext()
  const ref = useMenuItem()

  const handleScrollClick = () => {
    menuItems[1]?.element.scrollIntoView()
  }

  return (
    <Header
      ref={ref}
      variants={headerVariants}
      initial="initial"
      animate="animate"
      data-menu-label="о проекте"
    >
      <TextContent>
        <Title variants={titleVariants}>
          <Small variants={titlePartVariants}>
            <Left>за</Left>
          </Small>
          <Small variants={titlePartVariants}>
            <Right>нашу</Right>
          </Small>
          <motion.span variants={titlePartVariants}>
            <Left>свободу</Left>
          </motion.span>
        </Title>

        <IntroText variants={introVariants}>
          <p>
            Это проект о русской службе Радио Свобода. Десятилетиями редакция
            работала несмотря на смены политических режимов, преследования и
            цензуру. &quot;Свободу&quot; не раз пытались закрыть. В этом
            документальном сериале журналисты русской службы РС рассказывают,
            как профессия и исторические события изменили их жизни, как работа
            редакции выглядит изнутри и вспоминают о времени, когда журналистика
            в России не была преступлением.
          </p>
        </IntroText>
      </TextContent>

      <Images />
      <ScrollButton onClick={handleScrollClick}>
        <StyledIconArrow aria-label="Scroll Down" />
      </ScrollButton>
    </Header>
  )
}
